export const atacadistas = ["roldao"];
